"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allContentCreatorGroups = exports.firebaseSomosContentCreatorGroupName = exports.firebaseContentAdminGroupName = exports.firebaseContentCreatorGroupName = void 0;
exports.firebaseContentCreatorGroupName = 'contentCreator';
exports.firebaseContentAdminGroupName = 'contentAdmin';
exports.firebaseSomosContentCreatorGroupName = 'somosContentCreator';
exports.allContentCreatorGroups = [
    exports.firebaseContentCreatorGroupName,
    exports.firebaseContentAdminGroupName,
    exports.firebaseSomosContentCreatorGroupName
];
//# sourceMappingURL=permissionsGroupNames.js.map